import { Reservation } from '@app/models/micro/reservation.model';
import {AirLineSeamless} from "@utils/constants/airlineSeamless";
export class RequestFlightDetailsModel {
  reservationCode: string
  bookedLegCollection: BookedLegCollection[]


  constructor(reservation: Reservation) {
    this.reservationCode  = reservation.pnr;
    this.bookedLegCollection = reservation.flightSummary.segments.filter(segment => AirLineSeamless.includes(segment.operatingCarrier) || segment.operatingCarrier === 'AM')
      .map(segment => new BookedLegCollection(segment));
  }
}

export class BookedLegCollection {
  segmentCode: string
  departureAirport: string
  departureDate: string
  operatingCarrier: string
  operatingFlightCode: string

  constructor(segment) {
    const [date, time] = segment?.departureDateTime.split("T");
    this.segmentCode = segment?.segmentCode;
    this.departureAirport = segment?.departureAirport;
    this.departureDate = date;
    this.operatingCarrier = segment?.operatingCarrier;
    this.operatingFlightCode = segment?.operatingFlightCode;
  }
}
